import axios from "axios";
// const BASE_URL = process.env.REACT_APP_BASE_URL;

export const axiosApi = axios.create({ baseURL: "https://isola-dei-mori-be-production.up.railway.app" });

export const fakeApi = axios.create({
  baseURL: "https://jsonplaceholder.typicode.com",
});
